export const cancellation_policies = {
  the_green_lion:
    "Bookings can be amended and cancelled 30 days before the program start date without any costs. Bookings that are cancelled less than 30 days before the program start date will be charged the first week of the booking.",
};
